// 以后可能要抽出来 应付这种奇怪的场景
import React from 'react'
import { Container, Header } from '../../components_renew/Layout'

export class ImageFrame extends React.PureComponent {
  render () {
    const { imgSrc, title, btnRender, withHeader } = this.props
    return <Container>
      {withHeader ? <Header>{title}</Header> : null}
      <div className={'tutorial-details'}>
        <div className={'tutorial-details__wrapper'}>
          <img className={'tutorial-details__bg'} src={imgSrc} alt=''/>
          {btnRender && btnRender()}
        </div>
      </div>
    </Container>
  }
}
